import { Button } from 'native-base';

// Props
type Props = {
  onPress?: any;
  text: string;

  // Properties
  disabled?: boolean;
  isLoading?: boolean;

  // Icons
  startIcon?: any;
  endIcon?: any;

  // Styling (quick)
  mini?: boolean;
  fontWeight?: number;
  fontSize?: number;
  lineHeight?: number | string;
  bg?: string;
  color?: string;
  px?: number | string;
  py?: number | string;
  size?: number | string;
  width?: number | string;
  style?: object; // Styling (full)
};

export const SecondaryButton = ({
  onPress = undefined,
  text,

  disabled = false,
  isLoading = false,

  startIcon = undefined,
  endIcon = undefined,

  mini = undefined,
  bg = 'surface.200',
  color = 'white',
  fontSize = 16,
  fontWeight = 600,
  lineHeight = fontSize + 4,
  px = 5,
  py = '14px',
  size = 'md',
  width,
  style = undefined,
}: Props) => {
  return (
    <Button
      onPress={onPress}
      _pressed={{
        backgroundColor: bg,
        opacity: 0.8,
      }}
      _hover={{
        opacity: 1,
        backgroundColor: bg,
      }}
      opacity={disabled ? 0.4 : 0.75}
      isLoading={isLoading}
      disabled={disabled}
      startIcon={startIcon}
      endIcon={endIcon}
      px={px}
      py={py}
      bg={bg}
      size={size}
      width={width}
      rounded={'full'}
      borderWidth={mini ? 2 : 0}
      borderColor={mini ? color : bg}
      _text={{
        textAlign: 'center',
        color: color,
        fontSize: fontSize,
        fontFamily: 'body',
        fontWeight: fontWeight,
        fontStyle: 'normal',
      }}
      style={{ ...style }}
    >
      {text}
    </Button>
  );
};
